"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const ChatAvatar_1 = require("./ChatAvatar");
const ChatBadge_1 = require("./ChatBadge");
const ChatBrowserControls_1 = require("./ChatBrowserControls");
const ChatMembersHoverable_1 = require("./ChatMembersHoverable");
const constants_1 = require("../../constants");
const elements_1 = require("../../elements");
const translate_1 = require("../../translate");
const Actions = styled_1.default.div({
    display: 'flex',
    gap: constants_1.theme.spacing[3.5],
});
const Header = styled_1.default.div({
    alignItems: 'center',
    backgroundColor: constants_1.Color.WHITE,
    borderBottom: `${constants_1.theme.border.width.thin}px solid ${constants_1.Color.MEDIUM_GREY}`,
    boxShadow: constants_1.theme.boxShadow.normal,
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'space-between',
    // Reserve space for the box shadow:
    marginBottom: constants_1.theme.spacing[2],
    minHeight: ChatBrowserControls_1.CHAT_BROWSER_CONTROLS_MIN_HEIGHT,
    paddingBottom: constants_1.theme.spacing[3],
    paddingLeft: constants_1.theme.spacing[4],
    paddingRight: constants_1.theme.spacing[4],
    paddingTop: constants_1.theme.spacing[3],
});
const Information = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
    gap: constants_1.theme.spacing[1.5],
});
const Location = styled_1.default.h2({
    alignItems: 'center',
    color: constants_1.Color.DARKER_GREY,
    columnGap: constants_1.theme.spacing[2],
    display: 'flex',
    fontSize: constants_1.theme.font.size[6.5],
    fontWeight: constants_1.theme.font.weight.medium,
    lineHeight: constants_1.theme.lineHeight.normal,
    margin: 0,
    rowGap: constants_1.theme.spacing[1],
});
const Partner = styled_1.default.h3({
    alignItems: 'center',
    color: constants_1.Color.DARK_GREY,
    display: 'flex',
    gap: constants_1.theme.spacing[2],
    fontSize: constants_1.theme.font.size[6.5],
    fontWeight: constants_1.theme.font.weight.book,
    lineHeight: constants_1.theme.lineHeight.normal,
    margin: 0,
});
const Title = styled_1.default.h1((props) => ({
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: constants_1.theme.font.size[4],
    fontWeight: props.hasTitle ? constants_1.theme.font.weight.bold : constants_1.theme.font.weight.book,
    gap: constants_1.theme.spacing[2.5],
    lineHeight: constants_1.theme.lineHeight.normal,
    margin: 0,
}));
const WrappableContent = styled_1.default.div({
    alignItems: 'center',
    columnGap: 8,
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 2,
});
const ChatHeader = ({ actionsSlot, chat }) => {
    const t = (0, translate_1.useTranslations)();
    return ((0, jsx_runtime_1.jsxs)(Header, { children: [(0, jsx_runtime_1.jsxs)(Information, { children: [(0, jsx_runtime_1.jsxs)(Title, { hasTitle: !!chat.title, children: [chat.isInternal && ((0, jsx_runtime_1.jsx)(ChatBadge_1.ChatBadge, { children: t.chat_view.internal_conversation() })), chat.title || `(${t.chat_view.no_subject()})`] }), (0, jsx_runtime_1.jsxs)(Location, { children: [chat.location && ((0, jsx_runtime_1.jsx)(elements_1.Icon, { color: constants_1.Color.DARKEST_MEDIUM_GREY, name: "HomeIcon", round: true })), (0, jsx_runtime_1.jsxs)(WrappableContent, { children: [chat.location, chat.badges?.map((props, idx) => ((0, jsx_runtime_1.jsx)(ChatBadge_1.ChatBadge, { ...props }, idx)))] })] }), (0, jsx_runtime_1.jsxs)(Partner, { children: [(0, jsx_runtime_1.jsx)(ChatAvatar_1.ChatAvatar, { image: chat.chatPartner.avatarUrl, isInternal: chat.isInternal, name: chat.chatPartner.name, size: "xs" }), (0, jsx_runtime_1.jsxs)(WrappableContent, { children: [chat.chatPartner.name, chat.chatPartner.badges?.map(ChatBadge_1.ChatBadge)] })] })] }), (0, jsx_runtime_1.jsxs)(Actions, { children: [chat.members && (0, jsx_runtime_1.jsx)(ChatMembersHoverable_1.ChatMembersHoverable, { members: chat.members }), actionsSlot] })] }));
};
exports.ChatHeader = ChatHeader;
